import {AppUrls} from 'shared/config/model/urls';
import {Pages} from 'shared/config/model/pages';

import React from 'react';
import {i18n} from '@lingui/core';
import {t} from '@lingui/core/macro';

import {ExceededModal} from 'entities/user';
import {IncidentsScreen} from 'entities/monitor';
import useHttpIncidentsScreen from 'features/http/model/useHttpIncidentsScreen';
import useHttpIncidentHeader from 'features/http/model/useHttpIncidentHeader';
import useHttpIncidents from 'features/http/model/useHttpIncidents';

import CreateHttpMonitorButton from '../HttpMonitor/CreateHttpMonitorButton/CreateHttpMonitorButton';
import HttpMonitorModal from '../HttpMonitor/HttpMonitorModal';

import HttpIncidentRow from './HttpIncidentRow/HttpIncidentRow';
import HttpIncidentFiltersModal from './HttpIncidentFilters/HttpIncidentFiltersModal';
import HttpIncidentExportModal from './HttpIncidentExport/HttpIncidentExportModal';

const HttpIncidentsScreen: React.FC = () => {
    const {
        data, isLoading, isFetching, refetch, sort, setSort, plugState,
        openCreate, closeCreate, isCreateOpen, isExceededOpen,
    } = useHttpIncidentsScreen();
    const {search, onSearchSubmit, summary, isSummaryLoading, isSummaryError, refetchSummary} = useHttpIncidentHeader();
    const {columns, tzString} = useHttpIncidents(false);

    return (
        <IncidentsScreen
            documentTitle={t`Инциденты мониторов | Overseer`}
            title={i18n._(Pages.HTTP_INCIDENTS)}
            backUrl={AppUrls.HTTP_MONITORS}
            isFetching={isFetching}
            refetch={refetch}
            summary={{
                ...summary,
                isLoading: isSummaryLoading,
                isError: isSummaryError,
                refetch: refetchSummary,
            }}
            onSubmitSearch={onSearchSubmit}
            searchValue={search}
            renderFilterModal={(state) => <HttpIncidentFiltersModal {...state}/>}
            renderExportModal={(state) => <HttpIncidentExportModal {...state}/>}
            plugState={plugState}
            createButton={<CreateHttpMonitorButton onClick={openCreate}/>}
            createText={t`Добавить сайт`}
            onCreate={openCreate}
            columns={columns}
            items={data?.items}
            rowFactory={(item) =>
                <HttpIncidentRow
                    key={item.id}
                    item={item}
                    tzString={tzString}
                    hideMonitor={false}
                />
            }
            isLoading={isLoading}
            pagination={data}
            sort={sort}
            setSort={setSort}
        >
            <HttpMonitorModal
                open={isCreateOpen}
                handleClose={closeCreate}
            />

            <ExceededModal
                isOpen={isExceededOpen}
                handleClose={closeCreate}
            />
        </IncidentsScreen>
    );
};

export default HttpIncidentsScreen;
